'use strict'

import angular from 'angular'

angular.module('core.buysheetclientfield.services', [])
    .factory('BuySheetClientFieldFactory', BuySheetClientFieldFactory)

/**
 * @ngInject
 */
function BuySheetClientFieldFactory(
    Restangular,
    ColumnValueType
) {
    var buySheetClientFields = Restangular.all('buysheetclientfields')
    var vars = buySheetClientFields.one('vars')
    var values = buySheetClientFields.one('values')

    /**
     *
     * @param queryParams
     * @returns {*|ICollectionPromise<T>|ICollectionPromise<any>|{method, params, headers}}
     */
    function getColumns(queryParams) {
        return buySheetClientFields.getList(_.extend({
            metadata: true,
            sort: 'label'
        }, queryParams));
    }

    /**
     * Get all selectable values for specific fields (enum values)
     * @param fields (fields can be undefined to fetch all)
     * @returns {*}
     */
    function getColumnValues(fields) {
        return values.one(ColumnValueType.SET).get(_.isUndefined(fields) ? '' : {fields: fields});
    }

    /**
     * Get all distinct values for specific fields
     * @param fields (fields can be undefined to fetch all)
     * @dataSource unused
     * @queryParams any additional query params
     * @returns {*}
     */
    function getFieldValues(fields, dataSource, queryParams) {
        return values.one(ColumnValueType.DISTINCT).get(
            _.extend(_.isUndefined(fields) ? {} : {fields: fields}, queryParams || {}));
    }

    /**
     * Get data for this resource
     * @param queryParams
     * @returns {*|ICollectionPromise<any>|ICollectionPromise<T>|{method, params, headers}}
     */
    function getData(queryParams) {
        return buySheetClientFields.getList(queryParams);
    }

    return {
        ecTasksSummary: buySheetClientFields,
        vars: vars,
        getColumns: getColumns,
        getColumnValues: getColumnValues,
        getFieldValues: getFieldValues,
        getData: getData
    }
}